module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toctitle"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Introduction"
    }
  }, [_vm._v("Introduction: Outsourcing: Opportunities and Challenges")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsparttitle"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Part01"
    }
  }, [_vm._v("Part One: How to Plan, Lead, and Manage Outsourcing Initiatives")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01"
    }
  }, [_vm._v("Chapter 1: Overview of the Outsourcing Process")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#sec1"
    }
  }, [_vm._v("Outsourcing Terminology")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#sec2"
    }
  }, [_vm._v("Levels of Outsourcing")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#sec3"
    }
  }, [_vm._v("Phases of the Outsourcing Process")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#sec4"
    }
  }, [_vm._v("Monitoring the Evolving Outsourcing Environment")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#sec5"
    }
  }, [_vm._v("Outsourcing versus Worldwide Sourcing")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#sec6"
    }
  }, [_vm._v("Facing the Challenges of Outsourcing")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#sec7"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: Making the Decision to Outsource")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Employing Best Practices in Decision Making")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Identifying Your Company’s Outsourcing Needs")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Identifying Reasons to Outsource")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Starting On the Outsourcing Path")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: What You Need to Know Before You Start")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What’s Driving Your Outsourcing Decision?")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Laying the Foundations of Outsourcing")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turning Vision into Reality")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Implementing Strategic Sourcing")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maintaining Control")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making an Informed Outsourcing Decision")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("End-Of-Chapter Review: Steps to Launch")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Note")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Assessing Cost, Benefit, and Risk for Your Outsourcing Venture")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conduct the Feasibility Study")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#sec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Do a Detailed Analysis of Requirements")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Define the Parameters of the Vendor Relationship")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#sec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Measuring Performance")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#sec23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Getting to the Bottom Line")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Outsourcing Options")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#sec24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outsourcing Options Today")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#sec25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Emerging Outsourcing Opportunities")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#sec26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Ideas, Projects, and Functions")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#sec27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Selecting Your Suppliers and Vendors")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#sec28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Understanding Your Needs")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#sec29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Compiling the Long List")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#sec30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Submitting RFIs and Shortlisting Candidates")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#sec31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Issuing a Request for Proposal")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#sec32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Determining All the Costs")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#sec33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Comparing Company Cultures")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#sec34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Phases of Outsourcing")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#sec35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: the First Three Months")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Managing Your Outsourcing Vendors")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Transitioning")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nurturing the Relationship")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Getting Management Support")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Defining the Scope of Work")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Learn—And Teach—To Cope With Change")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Double-Check Vendor Fit")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Provide Training")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Solicit Feedback")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Measuring Success")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Internal Management")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Technology Transfer")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Offshoring")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Navigating Contracts and Negotiations")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Invest in a Quality Request for Proposal")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commit to a Competitive Process")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Encourage Early Collaboration")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Measure Internal Service Level Performance")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Implementing Best Practices")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Establishing Contract Measurements")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drafting an Outsourcing Contract")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Managing the Outsourcing Contract")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maintaining Confidentiality")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Renegotiating or Terminating the Contract")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: New Career Opportunities in Outsourcing Management")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#sec60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chief Resource Officer Training")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#sec61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hiring a Certified Professional")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#sec62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Becoming or Hiring a Certified Professional")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#sec63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Producing Results")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Finding Top Outsourcers: Vendor Directory")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Avoiding Common Outsourcing Mistakes")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#sec64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Knowing When to Say No to Outsourcing")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#sec65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Covering Your Business Back")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#sec66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#sec103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Note")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsparttitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two: the Indispensable Guide to Finding an Outsourcing Career")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Strategizing for Success in the New Global Economy")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#sec67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Learning to Strategize")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#sec68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#sec69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Learning to Market Yourself in the Global Economy")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#sec70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Getting Back On Track after a Layoff")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#sec71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Climbing the Management Ladder")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#sec72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Certifying Your Knowledge")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#sec73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Hot Jobs in Outsourcing")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#sec74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taking Your Professional Temperature")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#sec75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finding Vendor Employers")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#sec76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Getting Hot")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#sec77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Directory of Outsourcing Industry Growth Positions")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#sec78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Finding an Offshore, Nearshore, or Bestshore Job")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter15#sec79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taking the Measure of Yourself")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter15#sec80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Revamping Your Resume for International Distribution")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter15#sec81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Using the Internet to Focus Your Job Search")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsparttitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three: the Indispensable Guide for Outsourcing Entrepreneurs")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Starting Down the Entrepreneurial Path to Outsourcing")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16#sec82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Having What It Takes")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16#sec83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selling Your Outsourcing Value Proposition")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16#sec84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Understanding Your Prospects’ Compelling Reason(S) to Outsource")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16#sec85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Being a Problem Solver")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16#sec86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16#sec104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Note")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Capitalizing On the Outsourcing Start-Up Boom")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter17#sec87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Laying the Groundwork")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter17#sec88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Staking Your Claim")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter17#sec89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Getting It Right")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter17#sec90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rules for Effective Vendor-Focused BPO Agreements")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter17#sec91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter17#sec92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Note")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: Starting an Outsourcing Business")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter18#sec93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pricing and Promotion")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Glossary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dbca8086","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 57
// module chunks = 0